import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditDepositComponent } from '@app/core/windows'; 


@Component({
  selector: 'deposits-crud',
  templateUrl: './deposits-crud.component.html',
  providers: [ DatasourceService ]
})
export class DepositsCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditDepositComponent, {static: false}) window !: CreateEditDepositComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Depósito';

  protected name: string = 'Depósitos';

  protected table: string = 'deposits';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}